import React, { useEffect, useState } from "react";
import { Award, TrendingUp, Package } from "lucide-react";
import api from "../../lib/api";
import { Card, Badge, Spinner, EmptyState } from "../../lib/ui";
import { fmtRp } from "../../lib/constants";

export default function SupplierPerfTab() {
  const [perf, setPerf] = useState(null);
  const [ana, setAna] = useState(null);

  useEffect(() => {
    api.get("/purchasing/suppliers/analytics").then(({ data }) => setPerf(data.rows || [])).catch(() => setPerf([]));
    api.get("/analytics/purchasing").then(({ data }) => setAna(data)).catch(() => setAna(null));
  }, []);

  const maxSpend = Math.max(1, ...((perf || []).map((s) => s.total_spend || 0)));

  return (
    <div className="space-y-5" data-testid="sc-supplier-perf">
      {ana && (
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-3">
          <Card className="flex items-center gap-3 p-4">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary-light text-primary"><TrendingUp size={20} /></span>
            <div><p className="text-xs font-bold text-ink-mute">Total Belanja (PO Diterima)</p><p className="font-heading text-xl font-extrabold text-ink">{fmtRp(ana.total_spend)}</p></div>
          </Card>
          <Card className="flex items-center gap-3 p-4">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-blue-600"><Package size={20} /></span>
            <div><p className="text-xs font-bold text-ink-mute">Jumlah PO Diterima</p><p className="font-heading text-xl font-extrabold text-ink">{ana.po_count}</p></div>
          </Card>
          <Card className="flex items-center gap-3 p-4">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-amber-50 text-amber-600"><Award size={20} /></span>
            <div><p className="text-xs font-bold text-ink-mute">Supplier Teratas</p><p className="truncate font-heading text-base font-extrabold text-ink">{(perf && perf[0]?.supplier_name) || "—"}</p></div>
          </Card>
        </div>
      )}

      <Card className="overflow-hidden p-0">
        <div className="border-b border-line px-5 py-4"><h3 className="font-heading text-base font-extrabold text-ink">Peringkat Supplier berdasarkan Belanja</h3></div>
        {!perf ? <div className="flex h-32 items-center justify-center"><Spinner className="h-7 w-7" /></div>
          : perf.length === 0 ? <div className="p-5"><EmptyState image={null} title="Belum ada data performa supplier" /></div>
          : (
            <div className="divide-y divide-line">
              {perf.map((s, i) => (
                <div key={s.supplier_id || i} className="px-5 py-3" data-testid={`sc-perf-row-${i}`}>
                  <div className="flex items-center gap-3">
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-app text-xs font-extrabold text-ink-soft">{i + 1}</span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate font-bold text-ink">{s.supplier_name || "—"}</p>
                      <div className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-app">
                        <div className="h-full rounded-full bg-primary" style={{ width: `${((s.total_spend || 0) / maxSpend) * 100}%` }} />
                      </div>
                    </div>
                    <div className="shrink-0 text-right">
                      <p className="font-heading font-extrabold text-ink">{fmtRp(s.total_spend)}</p>
                      <p className="text-[11px] text-ink-mute">{s.purchase_count || 0} pembelian{s.last_purchase ? ` · ${s.last_purchase}` : ""}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
      </Card>

      {ana?.top_spend_products?.length > 0 && (
        <Card>
          <h3 className="mb-3 font-heading text-base font-extrabold text-ink">Produk dengan Belanja Tertinggi</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-line text-left text-xs uppercase text-ink-mute"><tr><th className="py-2 pr-3">Produk</th><th className="py-2 pr-3 text-right">Qty</th><th className="py-2 pr-3 text-right">Belanja</th></tr></thead>
              <tbody className="divide-y divide-line">
                {ana.top_spend_products.map((p) => (
                  <tr key={p.product_id}><td className="py-2 pr-3 font-medium text-ink">{p.product_name}</td><td className="py-2 pr-3 text-right text-ink-soft">{p.qty} {p.unit || ""}</td><td className="py-2 pr-3 text-right font-semibold text-ink">{fmtRp(p.spend)}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
